var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgZxzx(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1741153601603,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 3576,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M310.1 941.7c-10.1 0-20.2-4.2-27.4-12.3-13.4-15.1-12-38.2 3.2-51.6l159.4-144.3c6.7-5.9 15.3-12.5 24.2-12.5h271.4c13.2 0 17.1-4.1 17.1-17.4V308.9c0-13.2-3.9-25.9-17.1-25.9H164.5c-13.2 0-27.5 12.6-27.5 25.9v394.8c0 13.2 14.3 17.4 27.5 17.4h129.3c20.2 0 36.5 16.3 36.5 36.5S314 794 293.8 794H164.5C111 794 64 757.2 64 703.6V308.9c0-53.5 47-98.9 100.5-98.9h576.4c53.5 0 90.1 45.3 90.1 98.9v394.8c0 53.5-36.6 90.4-90.1 90.4H483.4l-149 135.1c-7 6.1-15.7 12.5-24.3 12.5z",
    "p-id": 3577,
    fill: "#ffffff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M922.5 613.3c-20.2 0-36.5-16.4-36.5-36.5V182c0-13.2-7.8-28-21.1-28H288.6c-20.2 0-36.5-15.8-36.5-36s16.4-36 36.5-36H865c53.5 0 94.1 46.4 94.1 100v394.8c-0.1 20.1-16.4 36.5-36.6 36.5z",
    "p-id": 3578,
    fill: "#ffffff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgZxzx);
export default __webpack_public_path__ + "static/media/zxzx.a6b24eaa.svg";
export { ForwardRef as ReactComponent };